import { render, staticRenderFns } from "./First.vue?vue&type=template&id=31cef01a&scoped=true&"
import script from "./First.vue?vue&type=script&lang=js&"
export * from "./First.vue?vue&type=script&lang=js&"
import style0 from "./First.vue?vue&type=style&index=0&id=31cef01a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cef01a",
  null
  
)

export default component.exports